import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/system";
import React, { FC, ReactElement, ReactNode } from "react";
import { colors } from "../../theme";

export type SectionProps = {
  number: number;
  title: string | ReactElement;
  subtitle?: string | ReactElement;
  children?: ReactNode;
  titlePadding?: boolean;
  sx?: SxProps;
};

export const Section: FC<SectionProps> = (props) => {
  return (
    <Box sx={{ paddingTop: 2, ...props.sx }}>
      <Box sx={{ pl: props?.titlePadding ? { md: "23px" } : "" }}>
        <Typography variant="h5" component="div">
          {props.title}
        </Typography>
        {props.subtitle ? (
          <Typography color={colors.greyDark} variant="caption" component="div">
            {props.subtitle}
          </Typography>
        ) : null}
      </Box>
      <Box sx={{ paddingTop: 2 }}>{props.children}</Box>
    </Box>
  );
};
